export default __webpack_public_path__ + "static/media/privateLock.7a9c6399.svg";